import { useContext } from 'react';
import { NullableCompanyContext, NullableCompanyContextData } from './context';

export function useNullableCompanyContext(): NullableCompanyContextData {
    const data = useContext<NullableCompanyContextData | undefined>(
        NullableCompanyContext
    );

    if (!data) {
        throw new Error(
            "NullableCompanyContext unavailable. Are you sure you're using this in a nested component of an NullableCompanyContextProvider?"
        );
    }

    return data;
}
